<template>
    <div class="container py-2" style="">
        <div class="row mt-5" id="job-search-component">
            <form class="col-12" method="post" @submit.prevent="submit">
                <div class="row">
                <div class="col-md-11">
                <div class="form-row">
                    <div class="col-md-2">
                        <label for="type" style="display: none">{{$t('Type')}}</label>
                        <select class="form-control" id="type" name="type" v-model="fields.type">
                            <option value="">{{$t('All types')}}</option>
                            <option v-for="type in types" :value="type.toLowerCase()">{{$t(type)}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label for="sector" style="display: none">{{$t('Sector')}}</label>
                        <select class="form-control" id="sector" name="sector" v-model="fields.sector">
                            <option value="">{{$t('All sectors')}}</option>
                            <option v-for="sector in sectors" :value="sector">{{$t(sector)}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label for="country" style="display: none">{{$t('Location')}}</label>
                        <select class="form-control" id="country" name="country" v-model="fields.country">
                            <option value="">{{$t('All locations')}}</option>
                            <option v-for="(country, code) in countries" :value="code">{{country}}</option>
                        </select>
                    </div>
                    <div class="col-md-5">
                        <label for="title" style="display: none">{{$t('Title')}}</label>
                        <input type="text" class="form-control" name="title" id="title" v-model="fields.title"
                               :placeholder="$t('Title')">
                    </div>
                </div>

                <!-- ADVANCED FORM FIELDS -->


                <div class="form-row my-3 px-0 col-12" id="advanced-search-form">

                    <div class="col-md-4 mb-3">
                        <label for="language" style="display: none">{{$t('Language')}}</label>
                        <select class="form-control" id="language" name="language" v-model="fields.language">
                            <option value="">{{$t('All languages')}}</option>
                            <option v-for="(language, code) in languages" :value="code">{{language}}</option>
                        </select>
                    </div>
                    <div class="col-md-4 mb-3" v-if="fields.type === 'job' || fields.type === 'internship'">
                        <label for="contract-type" style="display: none">{{$t('Contract type')}}</label>
                        <select class="form-control" id="contract-type" name="contract-type"
                                v-model="fields.contract_type">
                            <option value="">{{$t('All contract types')}}</option>
                            <option v-for="contract_type in contract_types" :value="contract_type">{{$t(contract_type)}}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-4 mb-3" v-if="fields.type === 'training'">
                        <label for="mode" style="display: none">Mode</label>
                        <select class="form-control" id="mode" name="mode" v-model="fields.mode">
                            <option value="">{{$t('All modes')}}</option>
                            <option v-for="mode in modes" :value="mode">{{$t(mode)}}
                            </option>
                        </select>
                    </div>
                </div>
                </div>
                <div class="col-md-1 text-right">
                    <button type="submit" id="job-search" class="btn btn-outline-primary"><i
                        class="fas fa-search"></i></button>
                </div>

                </div>
            </form>
        </div>

        <div class="row">
            <div class="col-12" v-if="recentSearches.length > 0">
                <h3 class="text-center">{{$t('Recent searches')}}</h3>
                <hr/>

                <div v-for="search in recentSearches" class="col-md-4 d-inline-block" v-on:click="fillForm(search)">
                    <recent-search-component
                        :key="componentKey"
                        :countries="countries"
                        :data="search"
                    ></recent-search-component>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center m-3" v-if="this.resultsShow && postResults.length === 0">
                <h3 class="text-center mt-5">{{$t('No results found')}}</h3>
            </div>

            <div class="col-12 mt-5 text-right" v-if="resultsShow && postResults.length > 0">
                <label for="perPage">{{$t('Results per page')}}:</label>
                <select class="form-control col-1" name="perPage" id="perPage" style="display: inline"
                        v-model="resultsPerPage" @change="onChange($event)">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="0">{{$t('all')}}</option>
                </select>
            </div>

            <div class="col-12 text-center" v-if="pageCount > 1">
                <paginate
                    :key="paginatorKey"
                    :page-count="pageCount"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="$t('Prev')"
                    :next-text="$t('Next')"
                    :container-class="'pagination float-right mt-5'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                ></paginate>
            </div>

            <div class="col-12" v-if="resultsShow && postResults.length > 0">
                <h3 class="text-center">{{$t('Search results')}} <span class="badge badge-info">{{postResults.length}} {{$t('found')}}</span></h3>
            </div>
            <div class="col-12 mt-2" v-for="jobOffer in paginatedResults">
                <hr/>
                <job-search-results-component
                    :offer_id="jobOffer.id"
                    :title="jobOffer.title"
                    :location="jobOffer.country"
                    :original_location="jobOffer.original_location"
                    :company_name="jobOffer.company_name"
                    :company_logo="jobOffer.company_logo"
                    :contract_type="jobOffer.contract_type"
                    :sector="jobOffer.sector"
                    :expire_date="jobOffer.expire_date"
                    :created_at="jobOffer.created_at"
                    :type="jobOffer.type"
                    :isAdminCompany="jobOffer.isAdminCompany"
                ></job-search-results-component>
            </div>

        </div>
    </div>
</template>
<script>
    import JobSearchResultsComponent from './JobSearchResultsComponent'
    import RecentSearchComponent from './RecentSearchComponent'

    export default {
        props: ['job_offers', 'form_query', 'contract_types', 'types', 'sectors', 'languages', 'countries', 'search_route', 'index_route', 'trigger_search', 'redirect', 'modes'],
        data() {
            return {
                resultsPerPage: 10,
                currentPage: 0,
                componentKey: 0,
                paginatorKey: 0,
                show: false,
                resultsShow: false,
                fields: {
                    title: '',
                    country: '',
                    original_location: '',
                    company_name: '',
                    company_logo: '',
                    expire_date: '',
                    created_at: '',
                    type: '',
                    sector: '',
                    contract_type: '',
                    language: '',
                    mode: ''
                },
                postResults: [],
                recentSearches: []
            }
        },
        computed: {
            pageCount() {
                if (parseInt(this.resultsPerPage) >= this.postResults.length || parseInt(this.resultsPerPage) === 0 || this.resultsPerPage === '0') {
                    return 1;
                }
                let value = this.postResults.length / (parseInt(this.resultsPerPage) +1);
                return Math.ceil(value);
            },
            paginatedResults() {
                if (this.resultsPerPage === '0' || parseInt(this.resultsPerPage) === 0) {
                    return this.postResults;
                }
                let from = this.currentPage * this.resultsPerPage;
                let to = from + parseInt(this.resultsPerPage);

                return this.postResults.slice(from, to);
            }
        },
        methods: {
            onChange(event) {
                this.currentPage = 0;
                this.paginatorKey += 1;
            },
            fillForm: function (data) {
                this.fields = Object.assign(this.fields, JSON.parse(data.search_params));
                this.submit();
                this.getRecentSearches();
            },
            clickCallback(pageNum) {
                this.currentPage = pageNum - 1;
            },
            submit() {
                if (this.fields.type === 'training') {
                    this.fields.contract_type = '';
                } else {
                    this.fields.mode = '';
                }
                if (this.redirect) {
                    window.location = this.index_route + '?' + Object.keys(this.fields).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(this.fields[k])}`).join('&');
                    return;
                }
                if (this.job_offers) {
                    this.postResults = this.job_offers.jobOffers;
                    this.resultsShow = true;
                    this.job_offers = false;
                    Object.keys(this.form_query).forEach(key => {
                        if (this.form_query[key].length > 0 && this.form_query[key] !== '') {
                            this.fields[key] = this.form_query[key];
                        }
                    });
                    this.getRecentSearches();
                    return;
                }
                this.errors = {};
                axios.post(this.search_route, this.fields).then(response => {
                    this.postResults = response.data.jobOffers;
                    this.resultsShow = true;
                    this.getRecentSearches();
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                });
            },

            getRecentSearches() {
                axios.post('/offer/recent-searches').then(response => {
                    this.recentSearches = response.data.searches;
                    this.componentKey += 1;
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                });
            }
        },
        mounted() {
            if (this.trigger_search) {
                this.show = true;
                this.submit();
            }
            if (window.location.hash) {
                this.fields.type = window.location.hash.substring(1);
            }
        },
        components: {
            'job-search-results-component': JobSearchResultsComponent,
            'recent-search-component': RecentSearchComponent
        }
    }
</script>
